/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import 'quasar/dist/quasar.ie.polyfills.js'



import '@quasar/extras/roboto-font/roboto-font.css'

import '@quasar/extras/material-icons/material-icons.css'

import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'

import '@quasar/extras/material-icons-round/material-icons-round.css'




// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'




import 'src/css/pc-view.scss'

import 'src/css/app.scss'

import 'src/css/font-size.scss'

import 'src/css/reset.scss'

import 'src/css/iconfont/iconfont.css'


import Vue from 'vue'
import createApp from './app.js'




import qboot_Booti18n from 'boot/i18n'

import qboot_Bootcustomcomponents from 'boot/custom-components'

import qboot_Bootrequest from 'boot/request'

import qboot_Bootwebsocket from 'boot/websocket'

import qboot_Bootmixin from 'boot/mixin'

import qboot_Bootsvgindex from 'boot/svg-index'

import qboot_Bootglobal from 'boot/global'

import qboot_Bootelement from 'boot/element'

import qboot_Bootpolyfill from 'boot/polyfill'

import qboot_Bootlazyload from 'boot/lazyload'

import qboot_Bootgooglemap from 'boot/google-map'

import qboot_Bootpersistclient from 'boot/persist-client'

import qboot_Booterror_track from 'boot/error_track'



import { addPreFetchHooks } from './client-prefetch.js'










const publicPath = `/`


async function start () {
  const { app, store, router } = await createApp()

  
  // prime the store with server-initialized state.
  // the state is determined during SSR and inlined in the page markup.
  if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__)
  }
  

  
  let hasRedirected = false
  const redirect = url => {
    hasRedirected = true
    const normalized = Object(url) === url
      ? router.resolve(url).route.fullPath
      : url

    window.location.href = normalized
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  const bootFiles = [qboot_Booti18n,qboot_Bootcustomcomponents,qboot_Bootrequest,qboot_Bootwebsocket,qboot_Bootmixin,qboot_Bootsvgindex,qboot_Bootglobal,qboot_Bootelement,qboot_Bootpolyfill,qboot_Bootlazyload,qboot_Bootgooglemap,qboot_Bootpersistclient,qboot_Booterror_track]

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        store,
        Vue,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }
  

  
    
    const appInstance = new Vue(app)

    // wait until router has resolved all async before hooks
    // and async components...
    router.onReady(() => {
      
      addPreFetchHooks(router, store, publicPath)
      
      appInstance.$mount('#q-app')
    })
    

  

}

start()
